// eslint-disable-next-line
import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import errorSVG from 'assets/images/error.svg';
import { Description, ImgContainer, Title } from '../customComponents';

type Props = {
  errorTitle?: string;
  errorMessage?: string;
  errorDetail?: string;
  fullScreen?: boolean;
  minHeight?: number | string;
  onClickRetryButton?: () => void;
};

const ErrorScreen: React.FC<Props> = ({
  errorTitle = '¡Lo siento! Por ahora no está disponible esta información.',
  errorMessage = 'Volvé a intentarlo más tarde',
  errorDetail,
  onClickRetryButton,
  fullScreen,
  minHeight = fullScreen ? '100vh' : 250,
}) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      textAlign="center"
      marginBottom={2}
      minHeight={minHeight}
    >
      <ImgContainer>
        <img src={errorSVG} alt="Error inesperado" width="100%" />
      </ImgContainer>
      <Title>{errorTitle}</Title>
      <Description variant="body2" gutterBottom>
        {errorMessage}
      </Description>
      <Description variant="body2" gutterBottom>
        {errorDetail}
      </Description>
      {onClickRetryButton && (
        <Button
          data-testid="retry-button"
          variant="contained"
          color="primary"
          onClick={onClickRetryButton}
        >
          REINTENTAR
        </Button>
      )}
    </Box>
  );
};

export default ErrorScreen;
